import { render, staticRenderFns } from "./FormSign.vue?vue&type=template&id=4d27284a&scoped=true&"
import script from "./FormSign.ts?vue&type=script&lang=ts&"
export * from "./FormSign.ts?vue&type=script&lang=ts&"
import style0 from "./FormSign.vue?vue&type=style&index=0&id=4d27284a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27284a",
  null
  
)

export default component.exports